import * as React from 'react';
import * as _ from 'lodash'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useRouteMatch,
    useParams, useHistory
} from 'react-router-dom'
import { Navbar, Nav, NavDropdown, Form, Image, Button, FormControl } from 'react-bootstrap';
import { connect, useDispatch, useSelector } from "react-redux";

import { hasRole } from '../utils'
import { css } from 'glamor';
import { IAppState } from '../redux/reducers';
import { AuthStateT } from '../redux/reducers/authReducer';
import { SocketStateT } from '../redux/reducers/socketReducer';
import logoWhiteNavbar from '../assets/images/logo_white_navbar.png';
import logoImg from '../assets/images/logo.png';
import defaultUserImg from '../assets/images/default-user.png';
import pyramidIconV2 from '../assets/images/pyramid_icon_v2.png';
import { currentUserIsManager } from 'utils/currentUser';
const images = {
    logo_white_navbar: logoWhiteNavbar,
    logo: logoImg,
    defaultUser: defaultUserImg,
    pyramid_icon_v2: pyramidIconV2,
}

const styles = {

    tdLink: css({
        ':hover': { "textDecoration": 'none' },
    })
}


const NavLink: React.FunctionComponent<{
    children: React.ReactNode
    to?: string
    onClick?(e: any): void
    className?: string
}> = (props): JSX.Element => {
    // Conditionally wrapping content into a link
    const ContentTag = props.to ? Link : 'div';



    return (
        <ContentTag to={props.to} onClick={(e) => {
            e.preventDefault()
            if (props.onClick) {
                props.onClick(e)
            }
        }} className={props.className} >{props.children}</ContentTag>
    );
}

export interface INavBarProps {
    logout?(): void
}

const NavBar: React.FC<INavBarProps> = ({ logout }) => {
    const auth: AuthStateT = useSelector((state: IAppState) => state.auth)
    const socket: SocketStateT = useSelector((state: IAppState) => state?.socket)
    const [expanded, setExpanded] = React.useState(false);
    const userRoles = auth.userData && auth.userData.roles && _.isArray(auth.userData.roles) ? auth.userData.roles : []
    const isManager = currentUserIsManager()

    let history = useHistory()
    const whichHomeLink = () => {
        if (auth.token) return '/jobs'
        else return '/'
    }
    /**
       *
       * @param jobId
       */
    const naviagte = (path: string): void => {
        setExpanded(false)
        history.push({
            pathname: `${path}`
        });


    }



    const onToggle = () => {
        setExpanded(!expanded)
    }

    return (
        <>
            <Navbar bg='light'
                expand='lg'
                id='smuvs-navbar'
                className='d-flex justify-content-center align-items-center'
                expanded={expanded}
                onToggle={() => {
                    setExpanded(!expanded)
                }}>
                <NavLink className="navbar-brand" to={whichHomeLink()} onClick={() => { naviagte(whichHomeLink()) }}>
                    <Image style={{ width: 60 }} src={images.logo}></Image>
                    <span className='ml-2 pt-2' style={{ color: 'white', fontSize: '1.5em' }}>MoveSheet</span>
                </NavLink>

                <Navbar.Toggle aria-controls='smuvsrp-navbar-nav' />
                <Navbar.Collapse id='smuvsrp-navbar-nav'>
                    <Nav className='mr-auto'>
                        {/*!auth.token &&
                            <>
                                <NavLink to='/'>SmuvsRP</NavLink>
                                <NavLink to='/'>Companies</NavLink>
                                <NavLink to='/'>Workers</NavLink>
                                <NavLink to='/insurers'>Insurers</NavLink>
                            </>
                        */}

                        {/*auth.token && <NavLink to='/dashboard'>Dashboard</NavLink>*/}
                        {auth.token && <NavLink
                            onClick={() => { naviagte("/jobs") }}
                            className="nav-link"
                            to='/jobs' >Jobs</NavLink>}
                        {auth.token && isManager &&
                            <NavLink className="nav-link" onClick={() => { naviagte("/workers") }} to='/workers'>Workers</NavLink>}
                        {auth.token && isManager &&
                            <NavLink className="nav-link" onClick={() => { naviagte("/clients") }} to='/clients'>Clients</NavLink>}
                        {/*auth.token && <NavLink to='/documents'>Documents</NavLink>*/}
                        {auth.token && (isManager || hasRole(userRoles, ['worker']) == true) &&
                            <NavLink className="nav-link" onClick={() => { naviagte("/financials") }} to='/financials'>Financials</NavLink>}
                        {auth.token && hasRole(userRoles, ['administrator', 'manager', 'worker']) == true &&
                            <NavLink className="nav-link" onClick={() => { naviagte("/worker-dev") }} to='/worker-dev'>Worker Dev</NavLink>}
                    </Nav>
                    <Nav className="" >
                        {!auth.token &&
                            <>

                                <NavLink className="nav-link" onClick={() => { naviagte("/register") }} to='/register'>Register</NavLink>
                                <NavLink className="nav-link" onClick={() => { naviagte("/login") }} to='/login'>Login</NavLink>
                            </>
                        }
                        {auth.token &&
                            <NavDropdown
                                // alignRight
                                align={'end'}
                                // style={{margin:null}}
                                id="basic-nav-dropdown-login"
                                title={
                                    <Image src={auth.userData && auth.userData.profilePic ? auth.userData.profilePic : images.defaultUser}
                                        className="profile_img_thumbnail"
                                        roundedCircle
                                        thumbnail={true}
                                    />}>
                                {/* <NavLink className="nav-link" onClick={() => { naviagte("/documents") }} to='/documents'>Documents</NavLink> */}
                                {auth.token && hasRole(userRoles, ['administrator', 'manager']) == true &&
                                    <NavLink className="nav-link" onClick={() => { naviagte("/equipment") }} to='/equipment'>Equipment</NavLink>}
                                {auth.token && hasRole(userRoles, ['administrator']) == true &&
                                    <NavLink className="nav-link" onClick={() => { naviagte("/accounting") }} to='/accounting'>Accounting</NavLink>}
                                <NavLink className="nav-link" onClick={() => { naviagte("/settings") }} to='/settings'>Settings</NavLink>
                                <Nav.Link onClick={() => { logout() }}>Log Out</Nav.Link>
                            </NavDropdown>
                        }
                        {/* <span className={`${socket?.isConnected ? "bg-success" : "bg-danger"}`}>{socket?.isConnected ? "online" : "offline"}</span> */}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    );

}
export default NavBar;
export { NavBar }
